import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {withRouter, Router} from "react-router-dom";
import history from "./history"
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";


const AppRouter = withRouter(App);

ReactDOM.render(<ErrorBoundary message={"The app hit an unexpected error. Reloading the page usually fixes it."}>
    <Router history={history}>
        <AppRouter/>
    </Router>
</ErrorBoundary>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
